import { Box, Stack, Typography } from "@mui/material";
import { ReuseModal } from "../../ReuseModal";
import { SubBlock } from "../../export-data/SubBlock";
import { ReuseInput } from "../../ReuseInput";
import { useState } from "react";
import { openLinkHandler } from "../../../../utils/openLinkHandler";
import { INPUT_REGEX } from "../../../../utils/regex";
import { useExportRecommendedMutation } from "../../../../api";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { useParams } from "react-router-dom";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const ExportRecommendedCsvModal = ({ isOpen, onClose }: Props) => {
  const { campaign_id } = useParams();
  const [fileName, setFileName] = useState<string>("Export-data");
  const [isError, setIsError] = useState<boolean>(false);

  const [exportRecommended, { error: playbookError, isLoading }] =
    useExportRecommendedMutation();

  const errorHandler = (
    error: FetchBaseQueryError | SerializedError | undefined,
  ) => {
    toast.error(
      <CustomToast
        type={"error"}
        text={
          getErrorMessage(error || playbookError).globalError ||
          "Something went wrong. Please try again"
        }
        title={"Export Data Failed"}
      />,
    );
  };

  const submitHandler = () => {
    if (!campaign_id) return;

    exportRecommended({ campaign_id, file_name: fileName })
      .unwrap()
      .then((data) => {
        openLinkHandler(data.url, fileName);
        onClose();
      })
      .catch(errorHandler);
  };

  const inputChangeHandler = (value: string) => {
    setIsError(!value || !INPUT_REGEX.test(value));
    setFileName(value);
  };

  return (
    <ReuseModal
      isOpen={isOpen}
      isLoading={isLoading}
      onClose={onClose}
      title="Export to CSV"
      onSubmit={submitHandler}
      maxWidth="540px"
      submitBtnColor="#1C3C6C"
      submitBtnText="Export"
      isDisabled={isError || isLoading}
      isDisabledCancelBtn={isLoading || isError}
    >
      <Stack gap="16px">
        <SubBlock title="File name" text="What should be the CSV file name?" />
        <Stack direction="row" gap="8px" alignItems="center" py="16px">
          <Box
            sx={{
              position: "relative",
              width: "100%",
            }}
          >
            <ReuseInput
              name="company_name"
              handleInputChange={(key, value) => inputChangeHandler(value)}
              errorMessage={
                "Must contain only letters, numbers, and basic punctuation"
              }
              value={fileName}
              label="File Name*"
              placeholder="Example"
              isError={false}
              isDisabled={isLoading}
            />
          </Box>

          <Typography
            component="span"
            variant="body1"
            sx={{ fontWeight: 500, lineHeight: "26px" }}
            color="#4C545B"
          >
            .csv
          </Typography>
        </Stack>
      </Stack>
    </ReuseModal>
  );
};
